module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cl-303f56a616afb6bae962ead1475d28f8.svg";